import React from 'react';

import styles from './styles';

function About(): JSX.Element {

    return (
        <div id="about" className="container">
            <div className="infoText" style={styles.infoTextContainer}>
                <h1>About</h1>
                <p style={styles.infoText}>
                    EasySell offers e-sellers an easier way of inventory management. Online sellers can register their shops on the system and connect their online seller profiles by entering unique API keys provided by different retailers. Centralized data from different platforms can be insightful for sellers to manage their stocks, e.g decreasing stocks in one and increase on another one. Using EasySell is a strategy that benefits online sellers in all terms.
                </p>
            </div>
        </div>
    )
}


export default About;